package com.patronat.top.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable

// ==========================================================================
// COLOR SCHEME
// ==========================================================================

private val LightColorScheme = lightColorScheme(

    primary = Primary600,
    onPrimary = White,


    secondary = Primary400,
    onSecondary = White,


    background = White,
    onBackground = MineShaft900,


    surface = White,
    onSurface = MineShaft900,


    error = AccentPink,
    onError = White,

    // Рамки та розділювачі
    outline = MineShaft200,
    outlineVariant = MineShaft100
)


// ==========================================================================
// THEME COMPOSABLE
// ==========================================================================

@Composable
fun AppTheme(
    useDarkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    val colorScheme = LightColorScheme

    val typography = rememberAppTypography()

    MaterialTheme(
        colorScheme = colorScheme,
        typography = typography,
        content = content
    )
}